export default "__VITE_ASSET__D73FwuAF__"